module.exports = __webpack_public_path__ + "img/customer-icon-12.e4f1e769.png";